module.exports = __webpack_public_path__ + "static/media/A.c7473414.png";